import React, { useEffect, useState, useRef } from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'aos/dist/aos.css';
import Testimonial from "./IMGS/Testimonial.png";
import Testimonial_2 from "./IMGS/Testimonial_2.png";

//const API_BASE_URL = 'http://localhost/royaleheritagefiesta/api';
const API_BASE_URL = 'https://royaleheritagefiesta.com/royaleheritagefiesta/api';

const AboutUs = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  const [activeVideo, setActiveVideo] = useState(false);
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState({
    hero: { title: 'Crafting Royal Experiences', subtitle: 'Where legacy meets celebration — creating unforgettable moments of timeless elegance and grandeur', badge: '✦ SINCE 2015' },
    story: { 
      title: 'Where Royalty Meets Celebration', 
      lead: 'Creating unforgettable experiences that blend tradition with modern elegance since 2015', 
      description1: 'Royal Heritage Festia was born from a vision to bring the grandeur of royal celebrations to modern events.', 
      description2: 'Today, we create extraordinary experiences across the globe, from intimate royal dinners to spectacular concerts.', 
      stats: [{ number: '500+', label: 'Royal Events' }, { number: '50+', label: 'Global Partners' }, { number: '98%', label: 'Client Satisfaction' }], 
      image: '' 
    },
    mission: { 
      title: 'Our Mission', 
      description: 'To create unforgettable royal experiences that celebrate heritage, culture, and timeless elegance.', 
      list: ['Deliver royal excellence', 'Create lasting memories', 'Honor traditions', 'Exceed expectations'] 
    },
    vision: { 
      title: 'Our Vision', 
      description: 'To be India\'s most prestigious luxury event management company.', 
      list: ['Global recognition', 'Cultural preservation', 'Innovation in elegance', 'Timeless experiences'] 
    },
    values: { 
      title: 'Our Royal Values', 
      subtitle: 'The principles that guide every celebration we create', 
      items: [
        { icon: 'bi-globe', title: 'Royal Excellence', desc: 'We deliver nothing but the finest experiences.' },
        { icon: 'bi-gem', title: 'Timeless Elegance', desc: 'Creating experiences that blend tradition with modern sophistication.' },
        { icon: 'bi-people', title: 'Personalized Service', desc: 'Tailored experiences that reflect your unique vision.' },
        { icon: 'bi-star', title: 'Unforgettable Moments', desc: 'Crafting memories that last a lifetime.' },
        { icon: 'bi-shield-check', title: 'Trust & Integrity', desc: 'Building lasting relationships through honesty.' },
        { icon: 'bi-globe', title: 'Global Standards', desc: 'Bringing world-class excellence to every celebration.' }
      ] 
    },
    team: { 
      title: 'Meet Our Royal Team', 
      subtitle: 'The visionaries behind your celebrations', 
      members: [
        { name: 'Rajesh Singh', position: 'Founder & Creative Director', description: 'With over 15 years of experience in luxury events.', image: '' },
        { name: 'Priya Reddy', position: 'Head of Royal Experiences', description: 'Expertise in curating bespoke experiences.', image: '' }
      ] 
    },
    cta: { title: 'Ready to Experience Royalty?', subtitle: 'Let\'s create your unforgettable celebration together', button1_text: 'Plan Your Event', button2_text: 'Call Us', phone: '+919966252374' }
  });
  
  // Refs and state for auto-moving gallery
  const galleryScrollRef = useRef(null);
  const autoScrollIntervalRef = useRef(null);
  const [isGalleryHovered, setIsGalleryHovered] = useState(false);

  // Gallery images data for Royal Heritage Festia theme
  const galleryImages = [
    {
      thumbnail: 'https://images.unsplash.com/photo-1536392706976-e486e2ba97af?q=80&w=800&auto=format',
      full: 'https://images.unsplash.com/photo-1536392706976-e486e2ba97af?q=80&w=1200&auto=format',
      title: 'Royal Heritage Festia Grand Celebration',
      category: 'Royal Heritage'
    },
    {
      thumbnail: 'https://images.unsplash.com/photo-1576326062417-11b7c40e8ddf?w=800&auto=format',
      full: 'https://images.unsplash.com/photo-1576326062417-11b7c40e8ddf?w=1200&auto=format',
      title: 'Royal Dinners Extravaganza',
      category: 'Royal Dinners'
    },
    {
      thumbnail: 'https://images.pexels.com/photos/167491/pexels-photo-167491.jpeg?auto=compress&cs=tinysrgb&w=800',
      full: 'https://images.pexels.com/photos/167491/pexels-photo-167491.jpeg?auto=compress&cs=tinysrgb&w=1200',
      title: 'Music & Concerts Night',
      category: 'Music & Concerts'
    },
    {
      thumbnail: 'https://images.unsplash.com/photo-1711869206287-33a83984d6ee?w=800&auto=format',
      full: 'https://images.unsplash.com/photo-1711869206287-33a83984d6ee?w=1200&auto=format',
      title: 'Royal Heritage Festia Gala',
      category: 'Royal Heritage'
    },
    {
      thumbnail: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&auto=format',
      full: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200&auto=format',
      title: 'Royal Dining Experience',
      category: 'Royal Dinners'
    },
    {
      thumbnail: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=800&auto=format',
      full: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=1200&auto=format',
      title: 'Live Music Performance',
      category: 'Music & Concerts'
    },
    {
      thumbnail: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&auto=format',
      full: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=1200&auto=format',
      title: 'Grand Celebration Hall',
      category: 'Royal Heritage'
    },
    {
      thumbnail: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800&auto=format',
      full: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1200&auto=format',
      title: 'Live Concert Experience',
      category: 'Music & Concerts'
    },
    {
      thumbnail: 'https://images.unsplash.com/photo-1555244162-803834f70033?w=800&auto=format',
      full: 'https://images.unsplash.com/photo-1555244162-803834f70033?w=1200&auto=format',
      title: 'Royal Dinner Setup',
      category: 'Royal Dinners'
    }
  ];

  // Testimonials array with alternating images
  const testimonials = [
    {
      text: "The Royal Heritage Festia was absolutely magnificent! Every detail was perfect, from the decor to the hospitality. An unforgettable experience!",
      name: "Vikram Singh",
      title: "Event Attendee",
      image: Testimonial,
      rating: 5,
      event: "Royal Heritage Festia"
    },
    {
      text: "The Royal Dinners experience was beyond imagination. Truly world-class hospitality and culinary excellence. Highly recommended!",
      name: "Meera Kapoor",
      title: "Dinner Guest",
      image: Testimonial_2,
      rating: 5,
      event: "Royal Dinners"
    },
    {
      text: "The concert was spectacular! Perfect acoustics and unforgettable performances. A night to remember forever.",
      name: "Arjun Nair",
      title: "Music Lover",
      image: Testimonial,
      rating: 5,
      event: "Music & Concerts"
    },
    {
      text: "An exceptional event that blended tradition with modern elegance. The Royal Heritage Festia team exceeded all expectations.",
      name: "Priya Sharma",
      title: "Corporate Client",
      image: Testimonial_2,
      rating: 5,
      event: "Royal Heritage Festia"
    }
  ];

  // Fetch about content from API
  const fetchAboutContent = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/get-about-content.php`);
      if (response.data.success && response.data.data) {
        const fetchedData = response.data.data;
        setContent(prev => ({
          ...prev,
          ...fetchedData,
          hero: fetchedData.hero || prev.hero,
          story: fetchedData.story || prev.story,
          mission: fetchedData.mission || prev.mission,
          vision: fetchedData.vision || prev.vision,
          values: fetchedData.values || prev.values,
          team: fetchedData.team || prev.team,
          cta: fetchedData.cta || prev.cta
        }));
      }
    } catch (error) {
      console.error('Error fetching about content:', error);
    } finally {
      setLoading(false);
    }
  };

  // Auto-scroll gallery effect
  useEffect(() => {
    fetchAboutContent();
  }, []);

  useEffect(() => {
    const galleryContainer = galleryScrollRef.current;
    if (!galleryContainer) return;

    const startAutoScroll = () => {
      if (autoScrollIntervalRef.current) clearInterval(autoScrollIntervalRef.current);
      
      autoScrollIntervalRef.current = setInterval(() => {
        if (isGalleryHovered) return;
        if (!galleryContainer) return;

        const scrollSpeed = 1.2;
        let newScrollLeft = galleryContainer.scrollLeft + scrollSpeed;
        const maxScroll = galleryContainer.scrollWidth - galleryContainer.clientWidth;

        if (newScrollLeft >= maxScroll) {
          galleryContainer.scrollLeft = 0;
        } else {
          galleryContainer.scrollLeft = newScrollLeft;
        }
      }, 25);
    };

    startAutoScroll();

    const handleMouseEnter = () => setIsGalleryHovered(true);
    const handleMouseLeave = () => setIsGalleryHovered(false);

    galleryContainer.addEventListener('mouseenter', handleMouseEnter);
    galleryContainer.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      if (autoScrollIntervalRef.current) clearInterval(autoScrollIntervalRef.current);
      galleryContainer.removeEventListener('mouseenter', handleMouseEnter);
      galleryContainer.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [isGalleryHovered]);

  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({
        duration: 800,
        once: true,
        offset: 50,
        easing: 'ease-in-out'
      });
    }

    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
      setShowFloatingButtons(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/919966252374?text=Hi%20Royal%20Heritage%20Festia%20team,%20I%27m%20interested%20in%20your%20services.', '_blank');
  };

  const playVideo = () => {
    setActiveVideo(true);
    alert('Video player would open here - Experience the magic of Royal Heritage Festia');
  };

  // Get values array from API
  const valuesItems = Array.isArray(content.values?.items) && content.values.items.length > 0
    ? content.values.items
    : [
        { icon: 'bi-globe', title: 'Royal Excellence', desc: 'We deliver nothing but the finest experiences.' },
        { icon: 'bi-gem', title: 'Timeless Elegance', desc: 'Creating experiences that blend tradition with modern sophistication.' },
        { icon: 'bi-people', title: 'Personalized Service', desc: 'Tailored experiences that reflect your unique vision.' },
        { icon: 'bi-star', title: 'Unforgettable Moments', desc: 'Crafting memories that last a lifetime.' },
        { icon: 'bi-shield-check', title: 'Trust & Integrity', desc: 'Building lasting relationships through honesty.' },
        { icon: 'bi-globe', title: 'Global Standards', desc: 'Bringing world-class excellence to every celebration.' }
      ];

  // Get team members from API
  const teamMembers = Array.isArray(content.team?.members) && content.team.members.length > 0
    ? content.team.members
    : [
        { name: 'Rajesh Singh', position: 'Founder & Creative Director', description: 'With over 15 years of experience in luxury events.', image: '' },
        { name: 'Priya Reddy', position: 'Head of Royal Experiences', description: 'Expertise in curating bespoke experiences.', image: '' }
      ];

  // Get story stats from API
  const storyStats = Array.isArray(content.story?.stats) && content.story.stats.length > 0
    ? content.story.stats
    : [{ number: '500+', label: 'Royal Events' }, { number: '50+', label: 'Global Partners' }, { number: '98%', label: 'Client Satisfaction' }];

  // Get mission list from API
  const missionList = Array.isArray(content.mission?.list) && content.mission.list.length > 0
    ? content.mission.list
    : ['Deliver royal excellence', 'Create lasting memories', 'Honor traditions', 'Exceed expectations'];

  // Get vision list from API
  const visionList = Array.isArray(content.vision?.list) && content.vision.list.length > 0
    ? content.vision.list
    : ['Global recognition', 'Cultural preservation', 'Innovation in elegance', 'Timeless experiences'];

  if (loading) {
    return (
      <>
        <Navbar />
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '60vh',
          backgroundColor: '#f5f5f5'
        }}>
          <div className="spinner-border text-warning" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <style>{`
        /* ===== MAIN CSS - Matching Home Page ===== */
        body { 
          background: #111; 
          font-family: 'Montserrat', sans-serif; 
          margin: 0; 
          color: #333; 
        }

        /* MAIN CONTAINER */
        .main-container {
          background: #f5f5f5;
          width: 100%;
          max-width: 1400px;
          padding: 20px;
          border-left: 29.5px solid #060606;
          border-right: 29.5px solid #060606;
          box-shadow: 0 0 0 2px rgba(0,0,0,0.05);
          margin: 0 auto;
        }

        /* About Hero */
        .about-hero {
          position: relative;
          padding: 4rem 0 4rem;
          background: linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.8)), url('https://images.unsplash.com/photo-1536392706976-e486e2ba97af?q=80&w=2000&auto=format');
          background-size: cover;
          background-position: center;
          color: white;
          border-radius:15px;
          text-align: center;
          width:100% !important;
        }

        .about-hero h1 {
          color: white;
          font-family: 'Cinzel', serif;
          font-size: 3.5rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }

        .about-hero p {
          color: rgba(255,255,255,0.9);
          font-size: 1.1rem;
          max-width: 700px;
          margin: 0 auto;
        }

        .hero-badge {
          display: inline-block;
          background: rgba(255,255,255,0.2);
          backdrop-filter: blur(5px);
          color: white;
          padding: 0.5rem 1.5rem;
          border-radius: 40px;
          font-weight: 500;
          margin-bottom: 2rem;
          border: 1px solid rgba(255,255,255,0.3);
          font-size: 12px;
          letter-spacing: 2px;
        }

        /* Section Title */
        .section-title {
          text-align: center;
          margin: 40px 0 30px;
        }
        .section-title h2 {
          font-family: 'Cinzel', serif;
          font-size: 32px;
          font-weight: 700;
          color: #000;
          position: relative;
          display: inline-block;
          padding-bottom: 12px;
        }
        .section-title h2:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 2px;
          background: #000;
        }
        .section-title p {
          color: #666;
          font-size: 14px;
          margin-top: 12px;
        }
        .section-tag {
          color: #b8860b;
          font-weight: 600;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 2px;
          display: inline-block;
          margin-bottom: 1rem;
        }

        /* Story Section */
        .story-section {
          padding: 3rem 0;
          background: #f5f5f5;
        }

        .story-image {
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          height: 450px;
        }

        .story-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s;
        }

        .story-image:hover img {
          transform: scale(1.05);
        }

        .story-content h2 {
          font-family: 'Cinzel', serif;
          font-size: 2.2rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          color: #000;
        }

        .story-content .lead {
          font-size: 1.1rem;
          color: #b8860b;
          font-weight: 500;
          margin-bottom: 1.5rem;
        }

        .story-content p {
          color: #666;
          margin-bottom: 1rem;
          line-height: 1.8;
        }

        .stats-grid {
          display: flex;
          gap: 2rem;
          margin-top: 2rem;
          flex-wrap: wrap;
        }

        .stat-block {
          text-align: center;
          flex: 1;
        }

        .stat-block h3 {
          font-family: 'Cinzel', serif;
          font-size: 2rem;
          font-weight: 700;
          color: #b8860b;
          margin-bottom: 0.3rem;
        }

        .stat-block p {
          color: #666;
          margin: 0;
          font-size: 0.85rem;
        }

        /* Mission Vision Cards */
        .mission-vision {
          padding: 3rem 0;
          background: #fff;
        }

        .mission-card {
          background: #fff;
          border-radius: 16px;
          padding: 2.5rem;
          height: 100%;
          box-shadow: 0 5px 20px rgba(0,0,0,0.05);
          border: 1px solid #eee;
          transition: 0.3s;
        }

        .mission-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }

        .mission-icon {
          width: 70px;
          height: 70px;
          background: rgba(184,134,11,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
        }

        .mission-icon i {
          font-size: 2rem;
          color: #b8860b;
        }

        .mission-card h3 {
          font-family: 'Cinzel', serif;
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #000;
        }

        .mission-card p {
          color: #666;
          margin-bottom: 1.5rem;
          line-height: 1.6;
        }

        .mission-list {
          list-style: none;
          padding: 0;
        }

        .mission-list li {
          margin-bottom: 0.8rem;
          display: flex;
          align-items: center;
          gap: 0.8rem;
          font-size: 0.9rem;
          color: #666;
        }

        .mission-list li i {
          color: #b8860b;
          font-size: 1rem;
        }

        /* Values Section - Scrollable Cards (No Scrollbar) */
        .values-section {
          padding: 3rem 0;
          background: #f5f5f5;
        }

        .values-scroll-container {
          overflow-x: auto;
          padding-bottom: 1rem;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .values-scroll-container::-webkit-scrollbar {
          display: none;
        }

        .values-scroll-wrapper {
          display: flex;
          gap: 1.5rem;
          min-width: min-content;
        }

        .value-card {
          background: #fff;
          border-radius: 16px;
          padding: 2rem;
          text-align: center;
          transition: 0.3s;
          border: 1px solid #eee;
          width: 280px;
          flex-shrink: 0;
        }

        .value-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }

        .value-icon {
          width: 70px;
          height: 70px;
          background: rgba(184,134,11,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
        }

        .value-icon i {
          font-size: 2rem;
          color: #b8860b;
        }

        .value-card h4 {
          font-family: 'Cinzel', serif;
          font-size: 1.2rem;
          font-weight: 700;
          margin-bottom: 0.8rem;
          color: #000;
        }

        .value-card p {
          color: #666;
          font-size: 0.9rem;
          margin-bottom: 0;
          line-height: 1.6;
        }

        /* Gallery Section - Scrollable with Auto-Move (No Scrollbar visible) */
        .gallery-section {
          padding: 3rem 0;
          background: #fff;
        }

        .gallery-scroll-container {
          overflow-x: auto;
          padding-bottom: 1rem;
          scrollbar-width: none;
          -ms-overflow-style: none;
          cursor: grab;
          scroll-behavior: smooth;
        }

        .gallery-scroll-container::-webkit-scrollbar {
          display: none;
        }

        .gallery-scroll-wrapper {
          display: flex;
          gap: 1.5rem;
          min-width: min-content;
        }

        .gallery-item {
          position: relative;
          border-radius: 12px;
          overflow: hidden;
          cursor: pointer;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
          width: 320px;
          height: 280px;
          flex-shrink: 0;
        }

        .gallery-item a {
          display: block;
          width: 100%;
          height: 100%;
          text-decoration: none;
        }

        .gallery-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s;
        }

        .gallery-item:hover img {
          transform: scale(1.1);
        }

        .gallery-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);
          display: flex;
          align-items: flex-end;
          padding: 1.5rem;
          opacity: 0;
          transition: 0.3s;
        }

        .gallery-item:hover .gallery-overlay {
          opacity: 1;
        }

        .gallery-overlay span {
          color: white;
          font-weight: 500;
          font-size: 0.9rem;
          font-family: 'Cinzel', serif;
        }

        .gallery-overlay i {
          margin-left: 0.5rem;
        }

        /* Testimonials Section - Scrollable on mobile (No Scrollbar), row on desktop */
        .testimonials-section {
          padding: 3rem 0;
          background: #fff;
        }

        .testimonials-scroll-container {
          overflow-x: auto;
          padding-bottom: 1rem;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .testimonials-scroll-container::-webkit-scrollbar {
          display: none;
        }

        .testimonials-wrapper {
          display: flex;
          gap: 1.5rem;
        }

        .testimonial-card {
          background: #fff;
          border-radius: 16px;
          padding: 2rem;
          box-shadow: 0 5px 20px rgba(0,0,0,0.05);
          border: 1px solid #eee;
          transition: 0.3s;
          flex: 1;
          min-width: 280px;
        }

        .testimonial-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }

        .testimonial-card .quote {
          color: #b8860b;
          font-size: 2rem;
          opacity: 0.3;
          margin-bottom: 1rem;
        }

        .testimonial-card p {
          font-size: 0.95rem;
          color: #666;
          margin-bottom: 1.5rem;
          line-height: 1.7;
          font-style: italic;
        }

        .testimonial-client {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .client-avatar {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          overflow: hidden;
          border: 2px solid #b8860b;
        }

        .client-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .client-info h5 {
          font-size: 1rem;
          font-weight: 700;
          margin-bottom: 0.2rem;
          color: #000;
        }

        .client-info p {
          color: #b8860b;
          font-size: 0.8rem;
          margin: 0;
          font-style: normal;
        }

        .client-rating {
          color: #fbbf24;
          margin-top: 0.3rem;
          font-size: 0.8rem;
        }

        .event-badge {
          display: inline-block;
          background: rgba(184,134,11,0.1);
          color: #b8860b;
          padding: 0.2rem 0.8rem;
          border-radius: 20px;
          font-size: 0.7rem;
          font-weight: 600;
          margin-top: 0.8rem;
        }

        /* Desktop styles - testimonials in one row without scroll */
        @media (min-width: 992px) {
          .testimonials-scroll-container {
            overflow-x: visible;
          }
          .testimonials-wrapper {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1.5rem;
          }
          .testimonial-card {
            min-width: auto;
          }
        }

        /* Video Section */
        .video-section {
          padding: 3rem 0;
          background: #f5f5f5;
        }

        .video-card {
          background: #000;
          border-radius: 20px;
          overflow: hidden;
          position: relative;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
        }

        .video-thumbnail {
          position: relative;
          height: 450px;
          overflow: hidden;
        }

        .video-thumbnail img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0.7;
          transition: transform 0.5s;
        }

        .video-card:hover .video-thumbnail img {
          transform: scale(1.05);
        }

        .video-play-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80px;
          height: 80px;
          background: #b8860b;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: 0.3s;
          border: 3px solid white;
          z-index: 10;
        }

        .video-play-btn i {
          font-size: 2rem;
          color: white;
        }

        .video-play-btn:hover {
          transform: translate(-50%, -50%) scale(1.1);
          background: #9b6e09;
        }

        .video-content {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 2.5rem;
          background: linear-gradient(to top, rgba(0,0,0,0.9), transparent);
          color: white;
        }

        .video-content h3 {
          color: white;
          font-family: 'Cinzel', serif;
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
        }

        .video-content p {
          color: rgba(255,255,255,0.9);
          margin-bottom: 0;
          font-size: 0.95rem;
        }

        /* Team Section */
        .team-section {
          padding: 3rem 0;
          background: #f5f5f5;
        }

        .team-card {
          background: #fff;
          border-radius: 16px;
          padding: 2rem;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          border: 1px solid #eee;
          transition: 0.3s;
          height: 100%;
        }

        .team-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }

        .team-image {
          width: 150px;
          height: 150px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 auto 1.5rem;
          border: 3px solid #b8860b;
        }

        .team-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .team-card h4 {
          font-family: 'Cinzel', serif;
          font-size: 1.3rem;
          font-weight: 700;
          margin-bottom: 0.3rem;
          color: #000;
        }

        .team-card .position {
          color: #b8860b;
          font-weight: 600;
          font-size: 0.85rem;
          margin-bottom: 1rem;
        }

        .team-card p {
          color: #666;
          font-size: 0.9rem;
          margin-bottom: 1.5rem;
          line-height: 1.6;
        }

        .team-social a {
          width: 35px;
          height: 35px;
          background: #f5f5f5;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          color: #b8860b;
          margin: 0 0.3rem;
          transition: 0.2s;
          text-decoration: none;
        }

        .team-social a:hover {
          background: #b8860b;
          color: white;
          transform: translateY(-3px);
        }

        /* CTA Section */
        .cta-section {
          padding: 4rem 0;
          background: #000;
          margin: 20px 0;
          border-radius: 16px;
          text-align: center;
        }

        .cta-section h2 {
          font-family: 'Cinzel', serif;
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #fff;
        }

        .cta-section p {
          font-size: 1rem;
          color: #aaa;
          margin-bottom: 2rem;
        }

        .cta-buttons {
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
        }

        .btn-custom {
          border: 1px solid #fff;
          background: transparent;
          color: #fff;
          padding: 0.8rem 2rem;
          border-radius: 40px;
          font-size: 0.9rem;
          font-weight: 500;
          transition: 0.3s;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .btn-custom:hover {
          background: #fff;
          color: #000;
          border-color: #fff;
        }

        .btn-custom-primary {
          background: #b8860b;
          color: #fff;
          border: none;
          padding: 0.8rem 2rem;
          border-radius: 40px;
          font-size: 0.9rem;
          font-weight: 500;
          transition: 0.3s;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .btn-custom-primary:hover {
          background: #9b6e09;
          transform: translateY(-2px);
        }

        /* Floating Buttons */
        .floating-buttons {
          position: fixed;
          bottom: 20px;
          right: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px);
          transition: 0.3s;
        }

        .floating-buttons.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .floating-btn {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          border: none;
          cursor: pointer;
          transition: 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          color: #fff;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        }

        .floating-btn.home {
          background: #b8860b;
        }

        .floating-btn.whatsapp {
          background: #25d366;
        }

        .floating-btn.top {
          background: #000;
        }

        .floating-btn:hover {
          transform: scale(1.1);
        }

        /* Back to Top */
        .back-to-top {
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 45px;
          height: 45px;
          background: #b8860b;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          opacity: 0;
          visibility: hidden;
          transition: 0.2s;
          z-index: 99;
          border: none;
        }

        .back-to-top.show {
          opacity: 1;
          visibility: visible;
        }

        .back-to-top:hover {
          background: #9b6e09;
          transform: translateY(-3px);
        }

        /* Container */
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -0.75rem;
        }

        .col-lg-6, .col-md-6, .col-lg-8, .col-md-4 {
          padding: 0 0.75rem;
        }

        .col-lg-6 { flex: 0 0 50%; max-width: 50%; }
        .col-md-6 { flex: 0 0 50%; max-width: 50%; }
        .col-lg-8 { flex: 0 0 66.666%; max-width: 66.666%; }
        .col-md-4 { flex: 0 0 33.333%; max-width: 33.333%; }

        @media (max-width: 768px) {
          .col-lg-6, .col-md-6, .col-lg-8, .col-md-4 {
            flex: 0 0 100%;
            max-width: 100%;
            margin-bottom: 1rem;
          }
        }

        /* Responsive */
        @media (max-width: 992px) {
          .about-hero h1 { font-size: 2.5rem; }
          .story-image { height: 350px; margin-bottom: 2rem; }
        }

        @media (max-width: 768px) {
          .main-container { 
            width: 100%; 
            padding: 12px; 
            border-left: 17.5px solid #060606 !important;
            border-right: 17.5px solid #060606 !important;
            box-sizing: border-box;
          }
          .stats-grid { flex-direction: column; gap: 1rem; }
          .about-hero h1 { font-size: 2rem; }
          .video-thumbnail { height: 350px; }
          .video-play-btn { width: 60px; height: 60px; }
          .video-play-btn i { font-size: 1.5rem; }
          .video-content { padding: 1.5rem; }
          .video-content h3 { font-size: 1.3rem; }
          .section-title h2 { font-size: 1.8rem; }
        }

        @media (max-width: 576px) {
          .about-hero h1 { font-size: 1.5rem; }
          .about-hero p { font-size: 0.9rem; }
          .story-content h2 { font-size: 1.5rem; }
          .cta-section h2 { font-size: 1.5rem; }
          .cta-buttons { flex-direction: column; }
          .btn-custom, .btn-custom-primary { width: 100%; justify-content: center; }
        }
      `}</style>

      {/* MAIN CONTAINER */}
      <div className="main-container">
        {/* About Hero */}
        <section className="about-hero">
          <div className="container">
            <span className="hero-badge" data-aos="fade-down">{content.hero?.badge || '✦ SINCE 2015'}</span>
            <h1 data-aos="fade-up" data-aos-delay="100">{content.hero?.title || 'Crafting Royal Experiences'}</h1>
            <p data-aos="fade-up" data-aos-delay="200">{content.hero?.subtitle || 'Where legacy meets celebration — creating unforgettable moments of timeless elegance and grandeur'}</p>
          </div>
        </section>

        {/* Story Section */}
        <section className="story-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6" data-aos="fade-right">
                <div className="story-image img">
                  <img 
                    src={content.story?.image || 'https://images.unsplash.com/photo-1536392706976-e486e2ba97af?q=80&w=800&auto=format'} 
                    alt="Royal Heritage Festia"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="col-lg-6" data-aos="fade-left">
                <div className="story-content">
                  <span className="section-tag">✦ OUR STORY</span>
                  <h2>{content.story?.title || 'Where Royalty Meets Celebration'}</h2>
                  <p className="lead">{content.story?.lead || 'Creating unforgettable experiences that blend tradition with modern elegance since 2015'}</p>
                  <p>{content.story?.description1 || 'Royal Heritage Festia was born from a vision to bring the grandeur of royal celebrations to modern events. Starting from Hyderabad\'s cultural heart, we\'ve grown into one of India\'s most trusted names in luxury event management.'}</p>
                  <p>{content.story?.description2 || 'Today, we create extraordinary experiences across the globe, from intimate royal dinners to spectacular concerts, all while maintaining the highest standards of elegance and sophistication.'}</p>
                  
                  <div className="stats-grid">
                    {storyStats.map((stat, idx) => (
                      <div className="stat-block" key={idx}>
                        <h3>{stat.number}</h3>
                        <p>{stat.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Vision Section */}
        <section className="mission-vision">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-6" data-aos="fade-right">
                <div className="mission-card">
                  <div className="mission-icon">
                    <i className="bi bi-globe2"></i>
                  </div>
                  <h3>{content.mission?.title || 'Our Mission'}</h3>
                  <p>{content.mission?.description || 'To create unforgettable royal experiences that celebrate heritage, culture, and timeless elegance, exceeding every expectation with impeccable attention to detail.'}</p>
                  <ul className="mission-list">
                    {missionList.map((item, idx) => (
                      <li key={idx}><i className="bi bi-check-circle-fill"></i> {item}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-md-6" data-aos="fade-left">
                <div className="mission-card">
                  <div className="mission-icon">
                    <i className="bi bi-star"></i>
                  </div>
                  <h3>{content.vision?.title || 'Our Vision'}</h3>
                  <p>{content.vision?.description || 'To be India\'s most prestigious luxury event management company, setting new standards in royal celebrations and cultural experiences across the globe.'}</p>
                  <ul className="mission-list">
                    {visionList.map((item, idx) => (
                      <li key={idx}><i className="bi bi-check-circle-fill"></i> {item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section - Scrollable Cards (No Scrollbar) */}
        <section className="values-section">
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>{content.values?.title || 'Our Royal Values'}</h2>
              <p>{content.values?.subtitle || 'The principles that guide every celebration we create'}</p>
            </div>
            
            <div className="values-scroll-container" data-aos="fade-up">
              <div className="values-scroll-wrapper">
                {valuesItems.map((value, index) => (
                  <div className="value-card" key={index} data-aos-delay={100 * (index + 1)}>
                    <div className="value-icon">
                      <i className={`bi ${value.icon}`}></i>
                    </div>
                    <h4>{value.title}</h4>
                    <p>{value.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Section - AUTO-MOVING (No Scrollbar visible, infinite smooth scroll) */}
        <section className="gallery-section">
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>Event Gallery</h2>
              <p>Glimpses of our royal celebrations</p>
            </div>
            
            <div 
              className="gallery-scroll-container" 
              ref={galleryScrollRef}
              data-aos="fade-up"
              style={{ cursor: 'grab' }}
            >
              <div className="gallery-scroll-wrapper">
                {galleryImages.map((image, index) => (
                  <div className="gallery-item" key={index} data-aos-delay={100 * (index + 1)}>
                    <a href={image.full} data-lightbox="event-gallery" data-title={image.title} target="_blank" rel="noopener noreferrer">
                      <img src={image.thumbnail} alt={image.title} loading="lazy" />
                      <div className="gallery-overlay">
                        <span>{image.category} <i className="bi bi-arrow-right"></i></span>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Video Section */}
        <section className="video-section">
          <div className="container">
            <div className="video-card" data-aos="zoom-in">
              <div className="video-thumbnail">
                <img 
                  src="https://images.unsplash.com/photo-1711869206287-33a83984d6ee?w=1200&auto=format" 
                  alt="Royal Heritage Festia Video"
                  loading="lazy"
                />
                <div className="video-play-btn" onClick={playVideo}>
                  <i className="bi bi-play-fill"></i>
                </div>
              </div>
              <div className="video-content">
                <h3>Experience the Royal Magic</h3>
                <p>Watch how we transformed the Royal Heritage Festia Grand Gala into an unforgettable celebration</p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>What Our Guests Say</h2>
              <p>Experiences that speak for themselves</p>
            </div>
            
            <div className="testimonials-scroll-container" data-aos="fade-up">
              <div className="testimonials-wrapper">
                {testimonials.map((testimonial, index) => (
                  <div className="testimonial-card" key={index} data-aos-delay={100 * (index + 1)}>
                    <div className="quote"><i className="bi bi-quote"></i></div>
                    <p>"{testimonial.text}"</p>
                    <div className="testimonial-client">
                      <div className="client-avatar">
                        <img src={testimonial.image} alt={testimonial.name} loading="lazy" />
                      </div>
                      <div className="client-info">
                        <h5>{testimonial.name}</h5>
                        <p>{testimonial.title}</p>
                        <div className="client-rating">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <i className="bi bi-star-fill" key={i}></i>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="event-badge">{testimonial.event}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="team-section">
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>{content.team?.title || 'Meet Our Royal Team'}</h2>
              <p>{content.team?.subtitle || 'The visionaries behind your celebrations'}</p>
            </div>
            
            <div className="row g-4">
              {teamMembers.map((member, idx) => (
                <div className="col-md-6" key={idx} data-aos={idx === 0 ? "fade-right" : "fade-left"}>
                  <div className="team-card">
                    <div className="team-image">
                      <img 
                        src={member.image || (idx === 0 ? Testimonial : Testimonial_2)} 
                        alt={member.name}
                        loading="lazy"
                      />
                    </div>
                    <h4>{member.name}</h4>
                    <div className="position">{member.position}</div>
                    <p>{member.description}</p>
                    <div className="team-social">
                      <a href="#"><i className="bi bi-linkedin"></i></a>
                      <a href="#"><i className="bi bi-twitter-x"></i></a>
                      <a href="#"><i className="bi bi-envelope"></i></a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <h2 data-aos="fade-up">{content.cta?.title || 'Ready to Experience Royalty?'}</h2>
            <p data-aos="fade-up" data-aos-delay="100">{content.cta?.subtitle || 'Let\'s create your unforgettable celebration together'}</p>
            <div className="cta-buttons" data-aos="fade-up" data-aos-delay="200">
              <Link to={`tel:${content.cta?.phone || '+919966252374'}`} className="btn-custom-primary">
                <i className="bi bi-calendar-check"></i> {content.cta?.button1_text || 'Plan Your Event'}
              </Link>
              <a href={`tel:${content.cta?.phone || '+919966252374'}`} className="btn-custom">
                <i className="bi bi-telephone-fill"></i> {content.cta?.button2_text || 'Call Us'}
              </a>
            </div>
          </div>
        </section>
      </div>

      <Footer />

      {/* Floating Buttons */}
      <div className={`floating-buttons ${showFloatingButtons ? 'show' : ''}`}>
        <button className="floating-btn home" onClick={() => scrollToSection('home')}>
          <i className="bi bi-house-door"></i>
        </button>
        <button className="floating-btn whatsapp" onClick={handleWhatsAppClick}>
          <i className="bi bi-whatsapp"></i>
        </button>
        <button className="floating-btn top" onClick={handleBackToTop}>
          <i className="bi bi-arrow-up"></i>
        </button>
      </div>

      {/* Back to Top Button */}
      <div className={`back-to-top ${showBackToTop ? 'show' : ''}`} onClick={handleBackToTop}>
        <i className="bi bi-arrow-up"></i>
      </div>
    </>
  );
};

export default AboutUs;